import { createContext } from 'use-context-selector';

export const StateContext = createContext();
